import React from "react";

const VideoPlayer = ({ width = "320", height = "240", src, type }) => {
  return (
    <video width={width} height={height} controls>
      <source src={src} type={`video/${type}`} />
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoPlayer;
